import { MediaDto } from './media-dto.model';
import { CollectionBookmarkIndexDto } from './collection-bookmark-index-dto.model';

export interface MailForMailTemplateDto {
  SentOn: string;
  FromUserID: number;
  FromUserName: string;
  To: string;
  From: string;
  MailDirection: MailDirection;
  CC: string;
  BCC: string;
  Subject: string;
  Body: string;
  CollectionsID: number;
  VersionsID: number;
  InstancesID: number;
  AttachmentAdded: boolean;
  Attachments: string[];
  MediaAttachments: Array<MediaDto>;
  UnreplacedBookmarksSubject: boolean;
  UnreplacedBookmarksBody: boolean;
  BookmarksDto: CollectionBookmarkIndexDto;
  mailId: number | null; // ts only -> not mapped in API
}

export enum MailDirection {
  Outgoing = 1,
  Incoming = 2
}